module.exports = __webpack_public_path__ + "static/media/menu-bg.497d2285.webp";